











































import Vue from 'vue';
import layout from '@/libs/layout/school/branch';
import { Component, Prop } from 'vue-property-decorator';
import { TPage, TLayout } from '@/types/utils.d.ts';
import { branchMode } from '@/api/login.ts';
import { State } from 'vuex-class';
import * as api_school from '@/api/school';
// import Detail from './detail-dialog.vue';
const namespace = 'user';
@Component({
  components: {
    Detail: () => import('./detail-dialog.vue')
  },
  filters: {
    statusFilter (status: any) {
      if (status === 'A') {
        return '启用'
      }
      else if (status === 'I') {
        return '禁用'
      }
    },
    readOnlyFilter (val: any) {
      if (val === 1) {
        return '开启'
      }
      else if (val === 0) {
        return '关闭'
      }
    }
  }
})
export default class List extends Vue {
  detailForm = {
    id: '',
    name: '',
    status: '',
    cuStomerType: '',
    contactname: '',
    contactphone: '',
    adminemail: '',
    address: '',
    surplusCoursePackage: '',
    totalCoursePackage: '',
    teacherLimit: '',
    bindCount: '', // 剩余激活码数量
    readOnly: 0,  // 查看权限
    parentId: ''
  }

  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 0,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: TPage;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @State('userInfo', { namespace }) userInfo!: any;
  private layout: TLayout = layout;
  private handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  private handleSize(size: number) {
    this.handleOptions({ pageSize: size });
    this.getData();
  }
  /**
   * @description: 打开客户视角
   * @param {Number} orgId 分校的机构Id
   */
  async openCustomer(orgId: any) {
    let opts = {
      orgId,
      type: 1
    };
    let res = await this.getAccount(opts),
      gzHref = window.localStorage.getItem('admin-path'),
      gzToken = window.localStorage.getItem('admin-gz-token');

    let orgPath: any = window.localStorage.getItem('admin-org-path'),
      orgToken: any = window.localStorage.getItem('admin-org-token');
    let query = '';
    if (!gzHref && !gzToken) {
      query = `#auto=true&level=1&orgToken=${
        this.userInfo.token
      }&branchToken=${res}&orgHref=${encodeURIComponent(location.href)}`;
    } else {
      query = `#auto=true&level=2&gzToken=${gzToken}&orgToken=${
        this.userInfo.token
      }&branchToken=${res}&href=${encodeURIComponent(
        gzHref as string
      )}&orgHref=${encodeURIComponent(location.href)}`;
    }
    let url =
      process.env.NODE_ENV === 'production'
        ? 'https://crm-org.miaocode.com'
        : 'https://sit-crm-org.miaocode.com';
    this.$router.replace({
      path: url + query
    });
  }
  /**
   * @description: 获取客户视角账号信息
   */
  async getAccount(opts: any) {
    try {
      let res = await branchMode(opts);
      return res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }


  // add by_ALi
  private openDetail(orgId: any) {
    this.getDetail(orgId);
    (this.$refs.detailDialog as any).dialogVisible = true;
  }

  async getDetail(orgId: any) {
    try {
      // let res: any = await api_school.getBranchDetail({ orgId });
      let res: any = await api_school.getOrgInfo({ orgId });
      // console.log(res)
      this.detailForm = {
        ...this.detailForm,
        ...{
          id: res.orgInfo.id,
          name: res.orgInfo.name,
          status: res.orgInfo.status,
          cuStomerType: String(res.orgInfo.cuStomerType),
          contactname: res.orgInfo.contactname,
          contactphone: res.orgInfo.contactphone,
          adminemail: res.orgInfo.adminemail,
          address: res.orgInfo.address,
          surplusCoursePackage: res.orgInfo.surplusCoursePackage,
          totalCoursePackage: res.orgInfo.totalCoursePackage,
          teacherNo: res.orgInfo.teacherNo,
          teacherLimit: res.orgInfo.teacherLimit,
          bindCount: res.bindCount,
          readOnly: res.orgInfo.readOnly,  // 查看权限
          parentId: res.orgInfo.parentId  // 激活码分配查询id( 未用，直接用的id )
        }
      };
      console.log(this.detailForm)
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  handleClose() {
    (this.$refs.detailDialog as any).dialogVisible = false;
    Object.keys(this.detailForm).forEach(
      key => ((this.detailForm as any)[key] = '')
    );
  }
}
